import { useEffect, useState } from 'react';
import { api } from '../api.js';

// Auto-rotating cross-fade banner rather than a scrolling marquee -- easier to
// read on mobile, and doesn't fight dark mode / reduced-motion preferences.
export default function Ticker() {
  const [items, setItems] = useState([]);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    api.get('/api/widgets/announcements').then(setItems).catch(() => setItems([]));
  }, []);

  useEffect(() => {
    if (items.length < 2) return;
    const t = setInterval(() => setIndex((i) => (i + 1) % items.length), 6000);
    return () => clearInterval(t);
  }, [items.length]);

  if (items.length === 0) return null;

  return (
    <div className="bg-navy text-white">
      <div className="mx-auto flex max-w-6xl items-center gap-3 px-4 py-2">
        <span className="shrink-0 rounded-full bg-amber px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide text-charcoal">
          Notice
        </span>
        <p className="min-w-0 flex-1 truncate text-sm">{items[index].message}</p>
        {items.length > 1 && (
          <div className="flex shrink-0 gap-1">
            {items.map((_, i) => (
              <button
                key={i}
                onClick={() => setIndex(i)}
                className={`h-1.5 w-1.5 rounded-full transition ${i === index ? 'bg-white' : 'bg-white/30'}`}
                aria-label={`Show notice ${i + 1}`}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
}
